import { apiClient } from "../config";

async function createOrgaznization(data: any) {
  const res = await apiClient.post(`/admin/organizations`, data);
  return res.data;
}

export default createOrgaznization;
